import { http } from 'utils/http';
import { StatResult } from './types';

export const getStat = async () => {
  const { data } = await http.get<StatResult>(`/Stat`);
  return data;
};
